import { ProcedureStatus } from './procedures';
import { OrderType } from './enums';

// Centralized status flow map for order types
// Uses ProcedureStatus enum values for consistency and type safety

export const ORDER_TYPE_STATUS_FLOW: Record<string, ProcedureStatus[]> = {
  [OrderType.LAB]: [
    ProcedureStatus.SAVED_AS_DRAFT,
    ProcedureStatus.PENDING,
    ProcedureStatus.ORDERED,
    ProcedureStatus.SENT,
    ProcedureStatus.RECEIVED,
    ProcedureStatus.COLLECTED,
    ProcedureStatus.COMPLETED,
    ProcedureStatus.CANCELLED,    
    ProcedureStatus.REVIEWED
  ],
  [OrderType.IMAGING]: [
    ProcedureStatus.SAVED_AS_DRAFT,
    ProcedureStatus.PENDING,
    ProcedureStatus.ORDERED,
    ProcedureStatus.SENT,
    ProcedureStatus.RECEIVED,
    ProcedureStatus.COMPLETED,
    ProcedureStatus.CANCELLED,
    ProcedureStatus.REVIEWED
  ],
  [OrderType.PROCEDURE]: [
    ProcedureStatus.SAVED_AS_DRAFT,
    ProcedureStatus.PENDING,
    ProcedureStatus.ORDERED,
    ProcedureStatus.COMPLETED,
    ProcedureStatus.CANCELLED
  ],
  [OrderType.PHYSICAL_EXAM]: [
    ProcedureStatus.SAVED_AS_DRAFT,
    ProcedureStatus.PENDING,
    ProcedureStatus.COMPLETED,
    ProcedureStatus.CANCELLED
  ],
  [OrderType.REFERRAL]: [
    ProcedureStatus.SAVED_AS_DRAFT,
    ProcedureStatus.PENDING,
    ProcedureStatus.SENT,
    ProcedureStatus.COMPLETED,
    ProcedureStatus.CANCELLED
  ],
  [OrderType.GENERIC]: [
    ProcedureStatus.SAVED_AS_DRAFT,
    ProcedureStatus.PENDING,
    ProcedureStatus.COMPLETED,
    ProcedureStatus.CANCELLED
  ],
  [OrderType.INTERVENTION]: [
    ProcedureStatus.SAVED_AS_DRAFT,
    ProcedureStatus.PENDING,
    ProcedureStatus.COMPLETED,
    ProcedureStatus.CANCELLED
  ],
  [OrderType.RISK_ASSESSMENT]: [
    ProcedureStatus.SAVED_AS_DRAFT,
    ProcedureStatus.PENDING,
    ProcedureStatus.COMPLETED,
    ProcedureStatus.CANCELLED
  ],
  [OrderType.SURGICAL]: [
    ProcedureStatus.SAVED_AS_DRAFT,
    ProcedureStatus.PENDING,
    ProcedureStatus.ORDERED,
    ProcedureStatus.COMPLETED,
    ProcedureStatus.CANCELLED
  ]
}; 